import ExpenseDate from "./ExpenseDate";
import styles from "./ExpenseItem.module.css";

const ExpenseItem = (props) => {
  const { title, amount, date } =
    props.expenseData;
  return (
    <li
      className={
        styles[
          "expenses-expenseList__expenseItem"
        ]
      }
    >
      <ExpenseDate date={date} />
      <h2
        className={
          styles[
            "expenses-expenseList__expenseItem__title"
          ]
        }
      >
        {title}
      </h2>

      <h2
        className={
          styles[
            "expenses-expenseList__expenseItem__amount"
          ]
        }
      >
        {"$" + amount}
      </h2>
    </li>
  );
};

export default ExpenseItem;
